var map = {
	"./footer_de.json": [
		13866,
		3866
	],
	"./footer_en.json": [
		11810,
		1810
	],
	"./footer_hy.json": [
		83826,
		3826
	],
	"./footer_ru.json": [
		73796,
		3796
	],
	"./footer_ua.json": [
		39623,
		9623
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 30921;
module.exports = webpackAsyncContext;